const it = {
  'Language Key': 'it',
  'cui-org-info': 'informazioni organizzazione',
  'cui-sign-on-info': 'Registrati su informazioni',
  'cui-user-info': 'Info utenti',
  'cui-preferences': 'Preferenze',
  'cui-review': 'Revisione',
  'cui-org': 'Organizzazione',
  'cui-company-division': 'Azienda / Divisione',
  'cui-org-address': 'organizzazione Indirizzo',
  'cui-user-address': 'Indirizzo utente',
  'cui-country': 'Nazione',
  'cui-city': 'Città',
  'cui-state': 'Stato / Provincia',
  'cui-postal': 'Codice postale',
  'cui-user-id': 'ID utente',
  'cui-password': "Parola d'ordine",
  'cui-password-re': 'Reinserire la password',
  'cui-challenge-question': 'domanda di verifica',
  'cui-challenge-answer': 'risposta sfida',
  'cui-favorite-pet-q': 'Qual è il nome del tuo animale domestico preferito?',
  'cui-mother-q': 'Qual è il cognome da nubile di tua madre?',
  'cui-best-friend-q': 'Chi è il tuo migliore amico?',
  'cui-first-name': 'nome di battesimo',
  'cui-last-name': 'Cognome',
  'cui-email': 'E-mail',
  'cui-email-re': 'Reinserire e-mail',
  'cui-telephone': 'Numero di telefono',
  'cui-timezone': 'Fuso orario',
  'cui-submit': 'SOTTOSCRIVI',
  'cui-next': 'PASSO SUCCESSIVO',
  'cui-previous': 'PRECEDENTE',
  'cui-create-security-admin-account': 'Crea il tuo account di amministratore di sicurezza',
  'cui-skip-for-now': 'SALTA PER ORA',
  'icon-library': 'Icon Library',
  'cui-new-TLO': 'Nuova Organizzazione di primo livello',
  'cui-new-TLO-description': 'Selezionare questo metodo se si desidera aderire alla Borsa Covisint come una nuova organizzazione Covisint',
  'cui-new-division': 'nuova Divisione',
  'cui-new-division-description-start': 'Selezionare questo metodo se si desidera diventare il',
  'cui-new-division-description-end': "di una nuova divisione all'interno di un'organizzazione Covisint esistente.",
  'cui-security-administrator': 'Security Administrator',
  'cui-new-user': 'Nuovo utente',
  'cui-new-user-description': "Selezionare questo metodo se sei un dipendente di una esistente Covisint aderente che chiede l'accesso a un'applicazione vostra organizzazione sottoscrive o se non si è sicuri se l'organizzazione è registrata.",
  'cui-sign-up': 'Iscriviti',
  'cui-address': 'Indirizzo',
  'cui-organization-name': 'Azienda / Divisione',
  'cui-supplier-code': 'Codice fornitore',
  'cui-address-1': 'Indirizzo 1',
  'cui-address-2': 'Indirizzo 2',
  'cui-user-information': 'informazioni utente',
  'cui-organization-information': 'organizzazione Informazioni',
  'cui-sign-in-information': 'Accedi Informazioni',
  'cui-package-selection': 'Selezione dei pacchetti',
  'cui-welcome-popover': 'Le responsabilità degli amministratori della sicurezza saranno spiegati in dettaglio dopo aver selezionato un metodo di registrazione. Tuttavia, si può scegliere di cancellare la tua registrazione al fine di consentire un diverso membro della vostra organizzazioni comuni di registrare come il Security Administrator.',
  'create-account': 'Crea il tuo account',
  'cui-agree-covisint': 'Accetto il Covisint',
  'terms-of-service': 'Termini di servizio',
  'cui-and': 'e',
  'privacy-policy': 'politica sulla riservatezza',
  'cui-tos-agree': 'Devi accettare i Termini di servizio per continuare.',
  'cui-user-profile': 'Profilo utente',
  'cui-my-profile': 'Il mio profilo',
  'cui-login': 'Accesso',
  'cui-supplier-content': 'Aggiornare una volta la documentazione di progetto sono disponibili in. Questo è nella traduzione google doc. Lorem Ipsum. Altre cose. Codice Fornitore informazioni importanti. Mi piace tartarughe.',
  'cui-all-organizations': 'Tutto organizzazione:',
  'cui-application-select-info': "Si può sempre fare le selezioni dopo l'accesso per la prima volta.",
  'cui-all-applications': 'tutte le applicazioni',
  'cui-page-not-found': 'Pagina non trovata',
  'cui-page-not-found-content': 'La pagina che stai cercando potrebbe essere stato eliminato o mai esistito.',
  'cui-home': 'CASA',
  'cui-access-denied': 'Accesso negato',
  'cui-access-denied-content': 'Non sei autorizzato a visualizzare questa pagina.',
  'cui-registration-status': 'dello stato di registrazione',
  'cui-pending-status': 'In attesa di stato',
  'cui-pending-status-content': "Il tuo stato di registrazione è ancora in sospeso. Riceverai un'email con i dettagli a breve.",
  'cui-thank-you': 'Grazie',
  'cui-request-submitted': 'richiesta presentata',
  'cui-success': 'Successo',
  'cui-success-content': "La tua registrazione Covisint è stata presentata con successo. Riceverai un'email con i dettagli a breve.",
  'cui-check-your': 'Controlla il tuo',
  'cui-registration-status-lower': 'lo stato di registrazione',
  'cui-application-selection': 'Selezione Applicazione',
  'cui-applications': 'applicazioni',
  'cui-profile-settings': 'Impostazioni del profilo',
  'cui-name': 'Nome',
  'cui-update': 'Aggiornare',
  'cui-updated': 'aggiornato',
  'cui-error-try-again': 'Errore! Riprova?',
  'cui-back': 'Indietro',
  'cui-selections': 'Selezioni',
  'cui-add-org': 'Aggiungere Organizzazione',
  'cui-remove-org': 'rimuovere Organizzazione',
  'cui-select-org': 'selezionare Organizzazione',
  'cui-more-information': 'Maggiori informazioni',
  'cui-inv-user-popover-info': "Per motivi di sicurezza, è necessario registrarsi con l'e-mail il tuo invito è stato inviato. Questo può essere modificato all'interno di impostazioni utente quando la registrazione è completa.",
  'cui-org-profile': "Profilo dell'organizzazione",
  'cui-info': 'Informazioni',
  'cui-admins': 'amministratori',
  'lowercase-not-allowed': 'non avere tutte le lettere minuscole',
  'uppercase-not-allowed': 'non avere tutte le lettere maiuscole',
  'numbers-not-allowed': 'Non hanno tutti i numeri',
  'special-not-allowed': 'non hanno alcun simboli speciali (es: * +)',
  'chars-not-allowed': 'non contenere alcuno dei seguenti caratteri: {{disallowedChars}}',
  'words-not-allowed': 'non contiene nessuna delle seguenti parole: {{disallowedWords}}',
  'password-length': 'avere tra {{min}} e {{max}} caratteri',
  'password-rules': 'avere {{requiredNumberOfCharClasses}} dei seguenti:',
  'password-lowercase': 'almeno 1 lettera minuscola',
  'password-uppercase': 'almeno 1 lettera maiuscola',
  'password-number': 'almeno 1 numero',
  'password-special': 'almeno 1 simbolo speciale (es: * +)',
  'passwords-must': 'Le password devono:',
  'welcome-title': 'Registrati per una delle seguenti opzioni',
  'cui-application-name': "Nome dell'applicazione",
  'cui-application-tos': 'Recensione Termini e condizioni',
  'cui-application-tos-agreement': "Termini e condizioni dell'accordo",
  'cui-package-tos': 'Non hai accettato i termini per i pacchetti selezionati.',
  'cui-view-tos': 'Mostra termini e condizioni',
  'password-mismatch': 'Le password devono essere identiche',
  'cui-back-to-review': 'Indietro per rivedere',
  'email-mismatch': 'Le email devono corrispondere',
  'no-applications-selected': 'Non si dispone di tutte le applicazioni selezionate. Clicca qui per tornare alla selezione delle applicazioni.',
  'cui-all-fields-required': 'tutti i campi sono obbligatori',
  'cui-complete-registration': 'Completa la tua registrazione qui di seguito con',
  'cui-registered': 'Registrato',
  'cui-open': 'Aperto',
  'cui-close': 'Vicino',
  'cui-street-address': 'Indirizzo',
  'cui-zip': 'Cerniera lampo',
  'cui-language': 'linguaggio',
  'cui-phone-main': 'Principale',
  'cui-phone-office': 'Ufficio',
  'cui-phone-fax': 'Telefono / Fax',
  'cui-phone-mobile': 'Mobile',
  'cui-save': 'Salvare',
  'cui-cancel': 'Annulla',
  'cui-edit': 'modificare',
  'cui-phone': 'Telefono',
  'search-by-app-name': "Ricerca per nome dell'applicazione",
  'new-request': 'Nuova richiesta',
  'select-applications': 'selezionare Applicazioni',
  'browse-applications': 'Sfoglia Applicazioni',
  'go': 'Partire',
  'filter-list': 'Elenco filtri',
  'filter': 'Filtro',
  'owning-org': 'possedere Org',
  'my-applications': 'Le mie applicazioni',
  'app-summary': 'App Sommario',
  'granted': 'concesso',
  'bundled-applications': 'Applicazioni in bundle',
  'application-details': 'Dettagli applicazione',
  'my-claims': 'I miei reclami',
  'related-applications': 'Applicazioni correlate',
  'review-request': 'Richiesta di revisione',
  'back-to-search': 'Torna a Ricerca',
  'requested-items': 'elementi richiesti',
  'request-reason': 'Motivo della richiesta',
  'reason-im-requesting': 'Ragione per cui sto chiedendo',
  'you-must-enter-a-reason': 'È necessario immettere un motivo per richiedere questa applicazione',
  'cui-org-no-applications': "Sembra che l'organizzazione non ha alcuna applicazione. Si può sempre provare di nuovo dopo l'accesso.",
  'cui-filter-org-name': 'Filtra per nome organizzazione',
  'cui-address-example': 'Apt, Suite, Bldg. (opzionale)',
  'cui-filter-app-name': "Filtra per nome dell'applicazione",
  'cui-search-user-name': 'Cerca gli utenti per nome',
  'page': 'Pagina',
  'cui-num-results-page': 'risultati per pagina',
  'submit-request': 'Inviare la richiesta',
  'categories': 'categorie',
  'cui-answer': 'Risposta',
  'cui-enter-password': 'Inserire la password',
  'cui-enter-new-password': 'Inserire una nuova password',
  'cui-re-enter-new-password': 'Reinserire la nuova password',
  'granted-to-my-org': 'Concesso alla mia organizzazione',
  'collected-items-for-request': 'I prodotti raccolti per richiesta',
  'cui-invalid-password': 'Password non valida. Riprova.',
  'cui-faq': 'FAQ',
  'cui-frequently-asked-questions': 'Domande frequenti',
  'cui-admin-tools': 'Admin Tools',
  'cui-this-field-is-required': 'Questo campo è obbligatorio.',
  'cui-this-field-needs-to-be-longer': 'Questo campo deve essere più lungo.',
  'cui-you-need-to-agree-to-toc': 'È necessario accettare i Termini di servizio prima di continuare.',
  'cui-this-is-not-valid-email': 'Questo non è un indirizzo email valido.',
  'cui-my-app-requests': 'Richieste di applicazione',
  'cui-no-claims': 'Non ci sono richieste per questa applicazione.',
  'cui-no-details': 'Dati non disponibili.',
  'request': 'Richiesta',
  'all': 'Tutti',
  'no-selected-apps': 'Non hai selezionato tutte le applicazioni.',
  'basic-info': 'Informazioni di base',
  'cui-error-username-exists': 'ID utente esiste già! Si prega di scegliere un altro.',
  'password-reset': 'Reimpostazione della password',
  'current-password': 'Password attuale',
  'timezone-and-language': 'Fuso orario e lingua',
  'challenge-questions': 'Sfide Domande',
  'security-question-repeated': 'Questa risposta è già stato utilizzato.',
  'cui-by-date-added': 'Data aggiunta',
  'cui-alphabetically': 'Alfabetico',
  'active': 'Attivo',
  'pending': 'in attesa di',
  'suspended': 'Sospeso',
  'title': 'Titolo',
  'id': 'ID',
  'url': 'url',
  'privacy-terms': 'Termini e Condizioni',
  'help': 'Aiuto',
  'cui-learn-more-start': 'Per saperne di più',
  'cui-learn-more-end': 'sul perché chiediamo queste informazioni',
  'cui-org-hierarchy': "gerarchia dell'organizzazione",
  'directory': 'elenco',
  'userID': 'ID utente',
  'status': 'Stato',
  'locked': 'Bloccato',
  'rejected': 'Respinto',
  'removed': 'Rimosso',
  'sort': 'Ordinare',
  'refine': 'raffinare',
  'or': 'O',
  'organizations': 'organizzazioni',
  'roles': 'ruoli',
  'organization-applications': 'Applicazioni organizzazione',
  'unactivated': 'non attivato',
  'log-out': 'Disconnettersi',
  'welcome': 'benvenuto',
  'privacy': 'vita privata',
  'terms': 'condizioni',
  'user': 'Utente',
  'top-level-orgs': 'Top organizzazioni a livello',
  'invite-user': 'Invita utente',
  'invite-division': 'Invita Division',
  'username': 'Nome utente',
  'move': 'mossa',
  'no-bundled-or-related': 'No impacchettato o applicazioni correlate.',
  'cui-continue': 'Continua',
  'cui-no-org-divisions': 'Non ci sono divisioni organizzazione',
  'inactive': 'Inattivo',
  'deny': 'Negare',
  'approve': 'Approvare',
  'pending-request': 'Richiesta in sospeso',
  'review-approvals': 'recensione Approvazioni',
  'cui-package-no-claims': 'Questo pacchetto contiene senza pretese',
  'claims': 'reclami',
  'package-name': 'Nome del pacchetto',
  'submit-approvals': 'Invia Approvazioni',
  'view-details': 'Visualizza dettagli',
  'request-date': 'Data di richiesta',
  'registration-decision': 'decisione di registrazione',
  'requested': 'richiesto',
  'getting-user-info': 'Ottenere le informazioni utente ...',
  'approvals-submitted': 'approvazioni Inviato',
  'rejection-submitted': 'Rifiuto Inserito',
  'approval-summary': 'Sommario approvazione',
  'approved-items': 'PUNTI aPPROVATI',
  'rejected-items': 'Articoli Rifiutato',
  'registration-request-approved': 'richiesta di registrazione Approvato',
  'registration-request-rejected': 'richiesta di registrazione Rifiutato',
  'no-items-rejected': 'Non ci sono articoli rifiutati',
  'no-items-approved': 'Non ci sono articoli approvati',
  'registration-request': 'Richiesta di registrazione',
  'custom-api-loading': "Inizializzazione l'applicazione ...",
  'new-grant': 'concessione App',
  'search-by-package-name': 'Ricerca per nome del pacchetto',
  'search': 'Ricerca',
  'administartor-?': 'Amministratore?',
  'submit-grant-update': 'Invia aggiornamento concessione',
  'review-user-pending-approval': "Recensione dell'utente attesa di approvazione",
  'view-request-for': 'View Richiesta',
  'job-title': 'Titolo di lavoro',
  'query': 'domanda',
  'suspend-app': 'sospendere App',
  'new-grants': 'nuove sovvenzioni',
  'update-grant-settings': 'Impostazioni di sovvenzione di aggiornamento',
  'assign-new-grant-to': 'Assegnare alla nuova concessione',
  'division': 'Divisione',
  'redirecting-to-sso': 'Richiesta le credenziali',
  'included-applications': 'Applicazioni incluse',
  'selected-sub-packages': 'Selezionati Sub-Pacchetti',
  'specify-password': 'specificare la password',
  'suspend': 'Sospendere',
  'reset-password': 'Resetta la password',
  'confirm-password-reset': "Sei sicuro di voler reimpostare la password per l'utente?",
  'yes': 'sì',
  'within': 'entro',
  'search-within': "Cerca all'interno",
  'in-your-org': 'nella vostra org',
  'people': 'Persone',
  'revoke-package': 'Revoca Package',
  'cui-by-username': 'Nome utente',
  'cui-by-status': 'Stato',
  'cool-got-it': 'Fresco, capito',
  'organization-directory': 'Directory organizzazione',
  'org-nav-invite-links': 'Organizzazione di navigazione e collegamenti Invitation',
  'org-dir-filters': 'Filtri Organizzazione Directory',
  'org-dir-list': 'Organizzazione Lista Directory',
  'apps': 'applicazioni',
  'apps-upper': 'APPS',
  'history-upper': 'STORIA',
  'profile-upper': 'PROFILO',
  'roles-upper': 'RUOLI',
  'your-app-request-in-review': 'La tua richiesta candidatura è stata presentata',
  'error-generic': "C'è stato un problema caricamento dei dati in questa pagina. Riprova.",
  'cui-application-administrator': "attualmente non avere il ruolo di amministratore di applicazione, che deve essere assegnata prima che un utente possono essere concessi diritti di amministrazione per una data applicazione. Questa è un'impostazione dell'ora.",
  'cui-assign-confirm': 'Vuoi assegnare questo ruolo ora?',
  'cui-suspend-warning': 'sarà in grado di accedere a questa applicazione',
  'cui-suspend-confirm': 'Sei sicuro che desideri sospendere adesso?',
  'cui-notify-user': 'Notifica utente',
  'cui-users': 'utenti',
  'cui-no': 'No',
  'cui-remove': 'Rimosso',
  'cui-org-abbrev': 'Org',
  'cui-userProfile-user-error': 'Si è verificato un errore durante il recupero dei dati utente. Riprova.',
  'cui-userProfile-security-error': "C'è stato un errore il recupero dei dati domanda di sicurezza. Riprova.",
  'cui-userProfile-password-error': "C'è stato un errore il recupero dei dati dei criteri password. Riprova.",
  'cui-suspend-success': 'Questa applicazione è sospesa dal utente selezionato',
  'cui-unlock': 'Sbloccare',
  'cui-unlock-password-confirm': 'Sei sicuro che si desidera sbloccare la password di questo utente?',
  'cui-error-unlocking-password': "Spiacente, c'è stato un errore di sbloccare la password di questo utente.",
  'cui-error-person-request': "Impossibile recuperare i dati di richiesta di registrazione per l'utente.",
  'cui-error-email-exists': 'Indirizzo e-mail è già stata presa',
  'cui-password-history-rule': 'non corrispondono le tue precedenti {{}} numberOfPasswords password',
  'cui-password-policy': 'Criterio password',
  'cui-security-admin': 'Gli amministratori di sicurezza',
  'cui-button-loading-text': 'Caricamento in corso...',
  'cui-username-taken': 'Nome utente è preso',
  'cui-no-applications': 'Al momento ci sono applicazioni',
  'cui-mask-answers': 'Maschera risposte di sicurezza / Unmask',
  'cui-pwd-reset-success': 'Password Reset successo!',
  'cui-last-login': 'Ultimo accesso',
  'cui-need-different-app': 'Hai bisogno di una diversa applicazione',
  'cui-go-back-to': 'Ritornare a',
  'cui-tos-applications': 'Si prega di accettare i Termini e condizioni per le applicazioni selezionate',
  'cui-selected-apps': 'applicazioni selezionate',
  'cui-authentication-policy': 'criterio di autenticazione',
  'cui-selected': 'Selezionato',
  'cui-tac': 'Termini e condizioni',
  'cui-accept': 'Accettare',
  'cui-tac-agree': 'Devi accettare i Termini e le condizioni per continuare.',
  'cui-printer-friendly-tac': 'Condizioni Printer-friendly',
  'cui-my-history': 'La mia storia',
  'cui-status-history': 'La mia storia di stato',
  'cui-app-history': 'Storia applicazione',
  'cui-password-change-log': 'log modifica della password',
  'cui-date': 'Data',
  'cui-event-type': 'Tipo di evento',
  'cui-action-by': 'Azione eseguita da',
  'cui-notes': 'Gli appunti',
  'cui-try-again': 'Riprova.',
  'cui-password-change-log-error': 'Si è verificato un errore durante il recupero change log password.',
  'cui-userstatus-history-error': 'Si è verificato un errore durante il recupero della storia Stato utente.',
  'cui-claims-error': 'Si è verificato un errore durante il recupero crediti.',
  'cui-org-app-suspend-success': 'Questa applicazione è ora sospesa dalle organizzazioni selezionate, tutti gli utenti, e tutte le organizzazioni secondarie.',
  'cui-org-app-suspend-msg1': "Questa azione sospendere l'azione di tutti gli utenti e le organizzazioni sub, anche quando in uso attivo.",
  'cui-org-app-suspend-msg2': 'Sei sicuro di voler sospendere',
  'cui-from': 'a partire dal',
  'cui-application-granted-history': 'Applicazione di Grant Storia',
  'cui-application-requested-history': 'Application Request Storia',
  'approved': 'Approvato',
  'decision': 'Decisione',
  'evaluator': 'valutatore',
  'action': 'Azione',
  'cui-invalid-invitation': 'Invito o è già in uso o non valido',
  'cui-by-request-date': 'Data di richiesta',
  'cui-by-decision-date': 'decisione Data',
  'cui-no-orgs-for-name': 'Nessun organizzazioni trovato per il nome specificato. Si prega di provare con un nome diverso.',
  'requests': 'richieste',
  'no-pending-apps': 'Non ci sono richieste di applicazione in sospeso.',
  'description': 'Descrizione',
  'launch': 'Lanciare',
  'manage-applications': 'Gestire applicazioni',
  'request-type': 'Tipo di richiesta',
  'phase': 'Fase',
  'date-submitted': 'data Inserito',
  'cui-pending-requests-error': 'Si è verificato un errore durante il recupero / aggiornamento richieste.',
  'no-requests-by-name': 'Nessuna richiesta trovato per il nome specificato. Si prega di provare con un nome diverso.',
  'cannot-change-password': 'Non è possibile modificare la password ora',
  'select-claims': 'selezionare i reclami',
  'grant-reason': 'concessione Motivo',
  'grants-assigned': 'Nuove borse assegnate',
  'suspend-error': "C'è stato un errore di sospendere le richieste.",
  'unsuspend-error': "C'è stato un errore nelle richieste Riattivare.",
  'approval': 'Approvazione',
  'administrator': 'Amministratore',
  'submitted': 'Inserito',
  'no-bundled': 'Nessuna applicazione in bundle',
  'disallowed-password-rule': 'Non può contenere una parola nella lista parole annullato',
  'request-approve-or-rejected': 'Questa richiesta è o Approvato / rifiutato',
  'application': 'Applicazione',
  'show-all': 'Mostra tutto',
  'cui-subject': 'Soggetto',
  'cui-es': '(Es)',
  'cui-invite-user': "Invita un utente all'interno",
  'cui-invite-user-success': 'la tua richiesta di invito utente ha inviato',
  'cui-email-recipt': 'Inserisci e-mail destinatario (per più separati da virgole)',
  'cui-invite-verbiage': 'Invita per una delle seguenti opzioni',
  'select': 'Selezionare',
  'change-org': 'Cambio Org',
  'cui-invite-user-sub': 'Registrarsi come utente per unire',
  'cui-invite-user-select': 'Ricerca di un org',
  'cui-send-invitation': 'Spedire un invito',
  'invite': 'Invitare',
  'cui-invite-tlo-success': 'Il tuo livello superiore richiesta organizzazione Invito spedito',
  'cui-invite-tlo': 'Invita una nuova organizzazione',
  'cui-invite-division-success': 'La vostra richiesta di società Invito spedito',
  'cui-invite-division': "Invita un'organizzazione",
  'cui-tlo-sub': 'Registrati come una nuova organizzazione',
  'cui-division-sub': "Registrati come un amministratore all'interno di",
  'search-by-org-name': "Ricerca per nome dell'organizzazione",
  'app-approval-error': "C'è stato un errore in sede di approvazione richieste App.",
  'modify-claims': 'modificare reclami',
  'unsuspend-app': 'Riattivare App',
  'remove-app': 'rimuovere App',
  'user-details': 'Dettagli utente',
  'reason': 'Ragionare',
  'required': 'necessario',
  'cui-unsuspend-confirm': 'Sei sicuro che desideri riattivare ora?',
  'unsuspend': 'Riattivare',
  'remove-confirm': 'Sei sicuro di desideri rimuovere adesso?',
  'remove': 'Rimuovere',
  'my-organization': 'La mia organizzazione',
  'request-app': 'richiesta App',
  'no-apps-found': 'Nessuna applicazione trovato.',
  'refine-search': 'Si prega di raffinare i criteri di ricerca.',
  'your-assign-role-success': 'Nuovo ruolo assegnato',
  'cui-assigned-roles': 'ruoli assegnati',
  'cui-available-roles': 'ruoli disponibili',
  'cui-browse-by-category': 'Sfoglia per categoria',
  'cui-back-navigation-requests': 'navigazione Indietro e richieste',
  'cui-search-results': 'risultati di ricerca',
  'cui-new-grant-search-results': 'Nuova concessione Risultati della ricerca',
  'cui-username-close': 'Nome utente e vicino di navigazione',
  'cui-user-no-apps': 'Utente non ha applicazioni',
  'cui-no-roles-assigned': 'Questo utente non ha ruoli assegnati.',
  'status-history': 'Storia di stato',
  'cui-no-status-history': 'Questo utente non ha una storia di stato.',
  'cui-pwd-reset-msg1': 'Password Reset è successo. Nuova password è:',
  'cui-pwd-reset-msg2': 'Nota: se si sta vedendo solo la metà prima e-mail la password poi la seconda metà password verrà inviata agli utenti registrati.',
  'users-upper': 'UTENTI',
  'hierarchy-upper': 'GERARCHIA',
  'privileges': 'privilegi',
  'expand-all': 'Espandi tutto',
  'collapse-all': 'Comprimi tutto',
  'no-records': 'Nessun record trovato.',
  'contact-us': 'Contattaci',
  'cui-error-organization-request': 'Impossibile recuperare i dati di richiesta di registrazione per questa organizzazione.',
  'cui-error-organization-app-request': 'Impossibile recuperare i dati di richiesta app per questa organizzazione',
  'cui-error-user-app-request': 'Impossibile recuperare i dati di richiesta di app per questo utente',
  'assign': 'Assegnare',
  'search-by-person-name': 'Ricerca per nome della persona',
  'grant-history': 'La storia di grant',
  'request-history': 'richiesta Storia',
  'social-login': 'login Social',
  'facebook': 'Facebook',
  'twitter': 'cinguettio',
  'link': 'collegamento',
  'unlink': 'Scollega',
  'invalid-url': 'Questo non è un URL valido.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'Amministrazione',
  'services': 'Servizi',
  'n-phase': 'N - fase di approvazione',
  'edit-package': 'Modifica pacchetto',
  'is-requestable': 'è richiedibile',
  'is-displayable': 'visualizzabile',
  'is-grantable': 'è concedibili',
  'require': 'richiedere',
  'is-requestable-desc': "Indicare se l'utente può richiedere questa applicazione.",
  'is-grantable-desc': "Indicare se questa applicazione può essere concessa direttamente dalla somministrazione società per l'utente",
  'is-displayable-desc': "Indicare se l'icona pacchetto dovrebbe essere visualizzato nella pagina Le mie applicazioni",
  'require-reason-desc': "Indica se il pacchetto richiesto all'utente di fornire un motivo per la richiesta questo pacchetto",
  'company-admin': 'Amministratore azienda',
  'application-admin': 'Applicazione Admin',
  'company-admin-desc': "Questa è la fase di approvazione di default, dovrebbe essere Sì se non v'è altra fase necessaria",
  'application-admin-desc': "L'applicazione utente richiesta deve essere approvata dall'amministratore dell'applicazione?",
  'add-admins': 'Aggiungere amministratori',
  'cardinality-indicator': 'Indicatore cardinalità',
  'cui-one': 'Uno',
  'cui-many': 'Molti',
  'claim-values': 'valori claim',
  'cui-add': 'Inserisci',
  'cui-view': 'vista',
  'cui-claim': 'Richiesta',
  'cui-category': 'Categoria',
  'cui-service': 'Servizio',
  'cui-delete': 'Elimina',
  'federation-conn': 'Federazione Connection',
  'updated-date': 'Data aggiornata',
  'target-url': 'URL di destinazione',
  'remote-app-id': 'Remote Application Id',
  'mobile-sso-url': 'URL SSO mobile',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'Pacchetto',
  'cui-create': 'Creare',
  'more-languages': 'Più lingue',
  'duplicate-language-error': 'lingue duplicati non sono consentiti',
  'cui-nextstep': 'Il prossimo',
  'create-package': 'Crea pacchetto',
  'manage-package-claims': 'Gestire pacchetto reclami',
  'cardinality-indicator-error': 'Indicatore cardinalità non può essere uno',
  'value-id-exists': 'ID valore esiste già',
  'claim-id-exists': 'Id rivendicazione esiste già',
  'cui-new': 'Nuovo',
  'package-success-content': 'Pacchetto creato con successo',
  'add-claims': 'Aggiungere reclami',
  'package-update-success': 'Pacchetto aggiornato con successo'
}

export {
  it
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/it.js